
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/shop-products",
      function () {
        return require("private-next-pages/seller/shop-products.js");
      }
    ]);
  